export default __webpack_public_path__ + "static/media/start-selling.c90c6610.svg";